import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FacebookCircle, TwitterCircle } from "sushiweb/Icons";
import axios from "axios";
import queryString from "query-string";
import {
  trackPopUp,
  trackingWithoutAuth
} from "../../../redux/dispatchers/userDispatcher";
import styles from "./Footer.module.scss";
import LinkedinCircle from "sushiweb/Icons/all/LinkedinCircle";

class Footer extends React.Component {
  openNewWebsite = () => {
    let expireDate = new Date();
    expireDate.setFullYear(expireDate.getFullYear() + 1);

    document.cookie =
      "RouterCookie=v1;expires=" + expireDate.toUTCString() + ";path=/";
    axios({
      url: window.location.origin + "/",
      headers: {
        Pragma: "no-cache",
        Expires: -1,
        "Cache-Control": "no-cache",
      },
    }).then(() => {
      document.cookie =
        "RouterCookie=v1;expires=" + expireDate.toUTCString() + ";path=/";
      window.location.replace("https://www.hyperpure.com/");
    });
  };

  sendTrackingIdForSocialMedia = (type) =>{
 
    let params = {
      ActionType: "CLICK",
      Element: "SOCIAL_MEDIA_LINKS",
      ReferenceId: 0,
      ReferenceType: type,
      Source: !this.props.isAuthenticated ? "FOOTER_LOG_OUT":"FOOTER_LOG_IN",
    }
    if (this.props.isAuthenticated) {
      this.props.actions.trackPopUp(params)
    }else{
      this.props.actions.trackingWithoutAuth(params)
    }
  }

  render() {
    const searchParam = queryString.parse(window.location.search);
    if(searchParam.source === "app"){
      return null
    }
    return (
      <footer className={styles.footer}>
        <div className={`container ${styles.content} fs-14`}>
          <div className="row">
            <div className="col-sm-7 col-md-3 mb-3P">
              <img
                src="../../../assets/images/logo_hp_black.svg"
                alt="Logo"
                style={{height: '40%', width: '40%'}}
              />
              <p>
                Hyperpure is an initiative by Zomato to provide fresh, hygienic, high quality ingredients and supplies to restaurants.
              </p>
            </div>
            <div className="col-sm-5 col-md-3 mb-3">
              <div>
                <span className="fs-14 w-600">Email</span>
                <br />
                <span className="text-gray">help@hyperpure.com</span>
              </div>
              <div className="mt-3">
                <span className="fs-14 w-600">Phone</span>
                <br />
                <span className="text-gray">+91 11 71565093</span>
              </div>
            </div>
            <div className="col-sm-7 col-md-4 mb-3">
              <span className="fs-14 w-600">Address</span>
              <br />
              <div className="text-gray mt-2">
                ZOMATO HYPERPURE PRIVATE LIMITED<br />GF 12A, 94 Meghdoot, Nehru
                Place, New Delhi- 110019
              </div>
            </div>
            <div className="col-sm-5 col-md-2 mb-3">
              <span className="fs-14 w-600">Follow Us</span>
              <p>
              <a
                  onClick= {()=> this.sendTrackingIdForSocialMedia("LINKEDIN")}
                  className=""
                  href="https://www.linkedin.com/company/zomatohyperpure/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedinCircle className={styles.facebookIcon} size={30} />
                </a>
                &nbsp;&nbsp;
                <a
                  onClick= {()=> this.sendTrackingIdForSocialMedia("TWITTER")}
                  className=""
                  href="https://twitter.com/zomato?lang=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TwitterCircle className={styles.twitterIcon} size={30} />
                </a>
                &nbsp;&nbsp;
                <a
                 onClick= {()=> this.sendTrackingIdForSocialMedia("FACEBOOK")}
                  className=""
                  href="https://www.facebook.com/zomato"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookCircle className={styles.facebookIcon} size={30} />
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="line-light" />
          <div className="row align-items-center">
            <div className={`col-sm-4 fs-14 text-gray ${styles.terms}`}>
              <a
                className="text-gray mr-4"
                href="https://www.zomato.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy
              </a>
              <Link to={"/buyerterms"} className="text-gray">
                Terms
              </Link>
            </div>
            <div className={`col-sm-8 fs-14 text-gray ${styles.copyright}`}>
              {/*onClick={this.openNewWebsite}*/}
              {/*<span className="link-red link-cookie">Switch To Old Look &nbsp;</span>*/}
              Copyright &copy; Hyperpure All Rights Reserved
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
let actions = {
  trackPopUp,
  trackingWithoutAuth
}

// export default Footer;
export default connect((state) => ({
  isAuthenticated: state.auth.isAuthenticated,
}),
(dispatch) => ({
  actions: bindActionCreators(
    actions,
    dispatch
  ),
}))(Footer);
